














import { Component, Vue, Prop, Watch } from "vue-property-decorator";
interface PropPaginate {
  totalRow: number;
  perPage: number;
  currentPage: number;
  limit: number;
}
@Component({
  name: "Paginate",
})
export default class Paginate extends Vue {
  @Prop({ required: true }) dataProp!: PropPaginate;

  public pageChange() {
    this.$emit('page-change',this.dataProp);
  }
}
